import { Injectable } from '@angular/core';
import { BotActionDTO } from '../Model/botActionDTO';
import { MapHelperService } from 'src/services/map-helper.service';
import { GeoClustersFrecuencyPlacesService } from 'src/app/features/locations-map/services/GeoClustersFrecuencyPlaces.service';
import { LocationsService } from 'src/app/features/locations-map/services/Locations.service';
import { EncriptionService } from '../../../services/Encription.service';

@Injectable({
  providedIn: 'root'
})
export class AzureBotService {

  //variables de identificacion de proyecto y usuario
    public userReferer = 'Mapix';
    public username = null;
    public password = null;
    public token = null;
    public signalIdentifier = null;

  // private tokenSubject = new BehaviorSubject<string | null>(null);

  constructor(private geoClustersFrecuencyCatalogService: GeoClustersFrecuencyPlacesService,
    private mapHelperService: MapHelperService,
    private encriptionService: EncriptionService,
    private locationsService: LocationsService) {
  }

  startAction(data: any) {
    var actionDTO: BotActionDTO = JSON.parse(data);
    console.log("accion de signal",actionDTO);
    
    switch (actionDTO.actionName) {
      case "OpenLocationDetails":
        this.OpenLocationDetails(actionDTO.actionData);
        break;
      case "LocationRecurrentPlaces":
        this.RecurrentPlacesStart(actionDTO.actionData);
        break;
    
      default:
        break;
    }
  }

  OpenLocationDetails(actionData: any) {
    this.locationsService.setLoading(true);
    const identifier = actionData.identifier.toUpperCase();
    this.mapHelperService.onFocusPin(identifier);
  }

  RecurrentPlacesStart(actionData: any) {
    // this.locationsService.setLoading(true);
    this.geoClustersFrecuencyCatalogService.setRecurrentPlaces(false);
    this.geoClustersFrecuencyCatalogService.setRecurrentPlaces(true);
    if(this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible){
      const identifier = actionData.identifier.toUpperCase();
      this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = identifier;
    }else{
      this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = "";
    }
  }

  setChanelData() {
    this.username = localStorage.getItem("user");
    this.token = localStorage.getItem("token");
    this.password = this.encriptionService.DecryptData(localStorage.getItem("password"));
  }
}
